import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';

import TableBody from '@material-ui/core/TableBody';
import TableHead from '@material-ui/core/TableHead';

import RideEdit from './RideEdit';
import RideRow from './RideRow';
import {
  FixedWidthTable,
  FlexTableRow,
  FabTableCell, MileageTableCell, RideTableCell, RouteBlockageTableCell,
} from './TableTools';

import { selectInactiveRides, selectRideAdminOptions } from './selectors';

class RideAdminInactiveList extends Component {
  static propTypes = {
    // state props
    detailOptions: PropTypes.shape({}),
    rides: PropTypes.arrayOf(PropTypes.shape({
      type: PropTypes.oneOf(['ride']).isRequired,
      id: PropTypes.string.isRequired,
    })).isRequired,
  };

  static defaultProps = {
    detailOptions: undefined,
  };

  render() {
    const { detailOptions, rides } = this.props;

    return (
      <div style={{ overflow: 'hidden auto', width: '100%' }}>
        <FixedWidthTable size="small">
          <TableHead>
            <FlexTableRow>
              <RouteBlockageTableCell>Stremming</RouteBlockageTableCell>
              <RideTableCell>Rit</RideTableCell>
              <MileageTableCell>Standen</MileageTableCell>
              <FabTableCell />
            </FlexTableRow>
          </TableHead>

          <TableBody>
            {rides.map(ride => <RideRow key={`ride-${ride.id}`} ride={ride} />)}
          </TableBody>
        </FixedWidthTable>

        <RideEdit
          open={detailOptions !== undefined}
          options={detailOptions}
        />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  detailOptions: selectRideAdminOptions(state),
  rides: selectInactiveRides(state),
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(RideAdminInactiveList);
